module.exports = __webpack_public_path__ + "img/googlecloud.eb6ed208.svg";